export default __webpack_public_path__ + "static/media/menu.b572a2b6.png";